import _ from 'lodash';
import ReactEChartsCore from 'echarts-for-react/lib/core';
import { LineChart } from 'echarts/charts';
import {
  GridComponent,
  LegendComponent,
  TooltipComponent
} from 'echarts/components';
import * as echarts from 'echarts/core';
import type { EChartsOption } from 'echarts';
import {
  breakpointsMediaQuery,
  getColor,
  useMediaQuery
} from '@/helpers/utils';
import { Card } from 'react-bootstrap';
import { useRef } from 'react';
import { serpTooltips } from '@/app/Serp/tooltip/serpTooltips';
import FalconCardHeader from '@/components/common/FalconCardHeader';
import HelpTooltip from '@/app/common/components/HelpTooltip';
import CardChartDropDown from '@/components/common/CardChartDropDown';
import { useTooltipHide } from '@/hooks/useTooltipHide';
echarts.use([LineChart, TooltipComponent, GridComponent, LegendComponent]);

interface SpamScoreProps {
  data?: number[];
  embedded?: boolean;
}

const SpamScore = ({ data, embedded = false }: SpamScoreProps) => {
  const cardRef = useRef<HTMLDivElement | null>(null);
  const chartRef = useRef<ReactEChartsCore | null>(null);
  const isMdUp = useMediaQuery(breakpointsMediaQuery.md);
  useTooltipHide(chartRef);

  const formattedData = data?.map((value, i) => {
    if (_.inRange(i, 0, 3))
      return { value, itemStyle: { color: getColor('success') } };
    else if (_.inRange(i, 3, 6))
      return { value, itemStyle: { color: getColor('warning') } };
    else if (_.inRange(i, 6, 9))
      return { value, itemStyle: { color: getColor('success') } };
  });

  // تنظیمات نمودار
  const getOption = (): EChartsOption => ({
    textStyle: {
      fontFamily: 'dana'
    },
    tooltip: {
      triggerOn: isMdUp ? 'mousemove' : 'click',
      trigger: 'axis',
      padding: [7, 10],
      backgroundColor: getColor('gray-100'),
      borderColor: getColor('gray-300'),
      textStyle: { color: getColor('gray-1100') },
      borderWidth: 1,
      formatter: (params: any) => {
        return `<div style="font-weight:bold;">${params[0].name}</div></br><div>${params[0].seriesName}: <span style="font-weight:bold;">${params[0].value}</span></div>`.toPersianDigit();
      },
      transitionDuration: 0,
      axisPointer: {
        type: 'shadow'
      }
    },
    xAxis: {
      type: 'category',
      data: [
        '1-10',
        '11-20',
        '21-30',
        '31-40',
        '41-50',
        '51-60',
        '61-70',
        '71-80',
        '81-90',
        '91-100'
      ],
      axisLine: {
        lineStyle: {
          color: getColor('gray-300'),
          type: 'solid'
        }
      },
      axisTick: { show: false },
      axisLabel: {
        show: true,
        color: getColor('gray-800'),
        fontWeight: 600,
        fontSize: 12,
        margin: 15,
        interval: window.innerWidth < 768 ? 'auto' : 0
      },
      splitLine: {
        show: false
      }
    },
    yAxis: {
      type: 'value',
      axisLabel: {
        show: true,
        color: getColor('gray-800'),
        margin: 5
      },
      splitLine: {
        show: true,
        lineStyle: {
          color: getColor('gray-200')
        }
      },
      axisTick: { show: false },
      axisLine: { show: false },
      min: 0
    },
    series: [
      {
        type: 'bar',
        name: 'بازه اسپم اسکور',
        data: formattedData as any,
        lineStyle: { color: getColor('primary') },
        itemStyle: {
          // color: getColor('primary'),
          borderRadius: [3, 3, 0, 0]
        },
        showSymbol: false,
        symbol: 'circle',
        smooth: false,
        emphasis: {
          scale: true
        }
      }
    ],
    grid: { right: '3%', left: '3%', bottom: '10%', top: '5%' }
  }) as EChartsOption;

  const chart = (
    <ReactEChartsCore
      ref={chartRef}
      echarts={echarts}
      option={getOption()}
      style={{ height: '23rem' }}
    />
  );

  if (embedded) return chart;

  return (
    <Card className="mb-3" ref={cardRef}>
      <FalconCardHeader
        title={
          <div>
            اسپم اسکور <HelpTooltip html={serpTooltips.spamScore} />
          </div>
        }
        titleTag="h6"
        className="py-2"
        light
        endEl={<CardChartDropDown cardRef={cardRef} chartRef={chartRef} />}
      />
      <Card.Body className="px-4">{chart}</Card.Body>
    </Card>
  );
};
export default SpamScore;
